import React from 'react';
import {getDebug} from '../library/GeneralUse';
import {Content} from '../components/PrimaryContent/Box/Content';
import {PrimaryContentBox} from '../components/PrimaryContent/Box/PrimaryContentBox';
import {PrimaryContentRow} from '../components/PrimaryContent/PrimaryContentRow';
import {DelayedMessage} from '../components/DelayedMessage';

const style = {
	delayedMessageContainer: `flex basis-1/12 justify-center items-center   w-full   text-center`,
	game: `flex justify-center items-center   min-w-[640px] min-h-[360px] recommended:min-w-[1024px] recommended:min-h-[576px]   bg-whirlwindDarkest`,
	innerGameContainer: `flex flex-col justify-center items-center   w-1/2 h-1/2`,
	loadingSpinnerContainer: `flex basis-11/12 justify-center items-center   w-full`,
	outerGameContainer: `flex justify-center`,
};

const DEBUG = getDebug('home');

export const Home = () => {
	DEBUG && console.clear();

	return (
		<PrimaryContentRow>
			<PrimaryContentBox tailwindcss={'basis-full max-w-full'}>
				<Content>
					<div className={style.outerGameContainer}>
						<div className={style.game}>
							<div className={style.innerGameContainer}>
								<div className={style.loadingSpinnerContainer}>
									<svg
										className="h-40 w-40 animate-spin"
										viewBox="0 0 100 100">
										<circle
											className="stroke-whirlwindPrimaryDark"
											cx="50"
											cy="50"
											fill="none"
											r="40"
											strokeWidth="10"
										/>
										<circle
											className="stroke-whirlwindPrimaryLight"
											cx="50"
											cy="50"
											fill="none"
											r="40"
											strokeDasharray="200"
											strokeDashoffset="210"
											strokeWidth="10"
										/>
									</svg>
								</div>
								<div className={style.delayedMessageContainer}>
									<DelayedMessage
										delay={10000}
										text="Nothing is actually loading here, this is a placeholder :P"
									/>
								</div>
							</div>
						</div>
					</div>
				</Content>
			</PrimaryContentBox>
		</PrimaryContentRow>
	);
};
